import { isEmpty } from 'ramda';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { AlertDialog } from '@zurich/ui/legacy/components';
import { alertDialogAtom } from '@zurich/ui/legacy/recoil';

export default function AlertDialogs() {
  const [open, setOpen] = useState(false);
  const [dialogState, setDialogState] = useRecoilState(alertDialogAtom);

  const handleClose = () => {
    if (dialogState.onCancel) dialogState.onCancel();
    setOpen(false);
  };

  const handleContinue = () => {
    if (dialogState.onContinue) dialogState.onContinue();
    setOpen(false);
  };

  useEffect(() => {
    // by default we open normal
    if (!isEmpty(dialogState)) setOpen(true);
  }, [dialogState, setOpen]);

  return (
    <AlertDialog
      open={open}
      title=""
      description=""
      {...dialogState}
      onExited={() => {
        setDialogState({});
      }}
      onContinue={handleContinue}
      onCancel={handleClose}
    />
  );
}
